import deepmerge from 'deepmerge';

import {config} from './config.base';

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type Config = DeepPartial<typeof config>;

export const extendConfig = (nextConfig: Partial<Config>): Config => deepmerge<Config>(config, nextConfig) as Config;
